import React, { ChangeEvent } from 'react';
import classNames from 'classnames';
import { InputBaseProps } from '../../../interfaces/interfaces';

import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface EmailInputProps extends InputBaseProps {
	label?: string,
	invalid?: boolean,
	invalidMessage?: string,
	toastError?: boolean
}

const EmailInput = ({ id, label, invalid, invalidMessage, className, placeholder, value, onBlur, onChange, toastError }: EmailInputProps) => {

	const isEmail = (email: string) => email === '' || email.includes('@');

	const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
		if (!isEmail(event.currentTarget.value) && toastError) {
			toast.error('Please enter a valid email address.', {
				icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
				toastId: 'emailInvalid',										// assign unique id, preventing toast from showing more than one at a time
				containerId: 'filterWarningToastContainer'  // set containerId so toast displays in specific toast container
			});
		} else {
			onBlur && onBlur(event);
		}
	};

	return (
		<div className="col px-0">
			<label htmlFor={id} className="mb-0">
				{label}
			</label>
			<div className="cc-input-group w-100">
				<input
					id={id}
					inputMode='email'
					type='email'
					className={classNames(invalid && 'cc-input-field--invalid', className && className)}
					placeholder={placeholder}
					value={value}
					onBlur={handleBlur}
					onChange={event => onChange(event.currentTarget.value)}
				/>
			</div>
			{invalid && invalidMessage && (
				<div className="invalid-error-message--input-field">{invalidMessage}</div>
			)}
		</div>
	);
};

export default EmailInput;